module.exports = {

    author: "@almayan",
    siteTitle: "alma yan - portfolio",
    siteShortTitle: "👩‍💻", // Used as logo text in header, footer, and splash screen
    siteDescription: "Multi-tasker, technical problem solver, organiser, with a passion in film & storytelling.",
    siteUrl: "https://lipingyan.com/",
    siteLanguage: "en_GB",
    siteIcon: "content/favicon.png", // Relative to gatsby-config file
    seoTitleSuffix: "alma yan", // SEO title syntax will be e.g. "Imprint - {seoTitleSuffix}"

    splashScreen: false, // Set this to true if you want to use the splash screen

    // You can create your own Medium feed with this rss to json converter: https://rss2json.com/
    // To access your Medium RSS feed, just replace this url with your username: https://medium.com/feed/@{yourname}
    // mediumRssFeed: "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fmedium.com%2Ffeed%2F%40konstantinmuenster",
    shownArticles: 6,
    
    // There are icons available for the following platforms: 
    // Medium, GitHub, LinkedIn, XING, Behance
    socialMedia: [
        {
            name: "Linkedin",
            url: "https://www.linkedin.com/in/alma-yan-78023b133/"
        },
        {
            name: "Work",
            url: "https://linktr.ee/lipingyan"
        },
        {
            name: "CV",
            url: "https://indd.adobe.com/view/8ccfc469-2c7a-45f9-a518-217a20c73e1c"
            //https://indd.adobe.com/view/9155e6cd-9883-40c9-a49e-7cea0f4aedcf
            //https://indd.adobe.com/view/07f5de88-53cc-4c52-a6b4-8e5858f6a9cb
            // url: "https://drive.google.com/file/d/1riIGU925XKAbgg4vVbqfClymGnLdW3xj/view?usp=sharing"
            //url: "https://www.dropbox.com/s/tgzi9v36vfsk1s5/AlmaYan-CV.pdf?dl=0"
           // url: "https://www.dropbox.com/s/t92ivbz33thet4y/AlmaYan-CV.pdf?dl=0"
        },
    ],
  
    navLinks: {
        menu: [
            {
                name: "About Me",
                url: "/#about",
            },
            {   name: "Timeline",
                url: "/#timeline",
            },
            {
                name: "Projects",
                url: "/#projects",
            },
        ],
        button: {
            name: "Contact",
            url: "/#contact",
        }
    },

    footerLinks: [
        {
            name: `Copyright &copy; ${new Date().getFullYear()} Alma Yan`,
            url: ""
        },
        {
            name: "",
            url: "/imprint"
        }
    ]
}